// extracted by mini-css-extract-plugin
export default {"checkboxInput":"FormCheckbox_checkboxInput__IBAKk"};